import { log } from '@/log'

export function moveCarousel(mediaId: string | null): void {
  if (!mediaId) {
    log.warn('selected FKU does not have carousel image media id.')

    return
  }

  const index = getIndexOfFirstMediumInFku(mediaId)
  if (index === undefined) {
    log.error('failed to resolve carousel index from selected FKU image media id.')

    return
  }

  ['pc', 'sp'].forEach((type) => {
    $(`#js-thumb-${type}-main`).slick('slickGoTo', index)
  })
}

function getIndexOfFirstMediumInFku(mediaId: string): string | undefined {
  const elem = document.querySelector(`div[data-media-id="${mediaId}"]`)

  return elem ? (elem as HTMLElement).dataset.indexOfFirstMediumInFku : undefined
}
